import { breakpointsConfig } from '~/lib/utils/breakpoints';
export const useEvaBreakpoints = () => {
  const {
    desktop,
    tablet,
    mobile,
    greater,
    greaterOrEqual,
    smaller,
    smallerOrEqual,
    between,
    isGreater,
    isGreaterOrEqual,
    isSmaller,
    isSmallerOrEqual,
    isInBetween,
    current,
  } = useBreakpoints(breakpointsConfig);

  const isDesktop = computed(() => {
    return desktop.value;
  });

  const isMobile = computed(() => {
    return !tablet.value && mobile.value;
  });

  const isTablet = computed(() => {
    return !desktop.value && tablet.value;
  });

  return {
    desktop,
    tablet,
    mobile,
    greater,
    greaterOrEqual,
    smaller,
    smallerOrEqual,
    between,
    isGreater,
    isGreaterOrEqual,
    isSmaller,
    isSmallerOrEqual,
    isInBetween,
    current,
    isDesktop,
    isMobile,
    isTablet,
  };
};
